import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/interview/mock/MockInterviewClient.tsx");
